(() => {
  const boot = document.querySelector('[data-nyx-design-3]');
  if (!boot || boot.dataset.ready === 'true') return;
  boot.dataset.ready = 'true';

  const root = document.body.classList.contains('nyx-design-3--enhanced')
    ? document.body
    : boot;
  const enhancedMotion = true;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion) document.documentElement.classList.add('nyx-motion');

  const items = [...document.querySelectorAll('[data-stream-item]')];
  const progress = document.querySelector('.scroll-progress');
  let scheduled = false;

  const updateProgress = () => {
    if (progress) {
      const available = document.documentElement.scrollHeight - window.innerHeight;
      const amount = available > 0 ? Math.min(window.scrollY / available, 1) : 0;
      progress.style.transform = 'scaleX(' + amount + ')';
    }
    if (enhancedMotion) root.classList.toggle('is-scrolled', window.scrollY > 12);
    scheduled = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(updateProgress);
      }
    },
    { passive: true }
  );
  window.addEventListener('resize', updateProgress, { passive: true });
  updateProgress();

  if (!reduceMotion && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      enhancedMotion
        ? { rootMargin: '8% 0px 8% 0px', threshold: 0.08 }
        : { rootMargin: '12% 0px 12% 0px', threshold: 0.01 }
    );
    items.forEach((item) => {
      if (item.getBoundingClientRect().top < window.innerHeight * 1.2) item.classList.add('is-visible');
      else revealObserver.observe(item);
    });
  } else {
    items.forEach((item) => item.classList.add('is-visible'));
  }

  const videos = [...document.querySelectorAll('.video-band video')];
  const setVideoReady = (video) => video.closest('.video-band')?.classList.add('is-media-ready');
  videos.forEach((video) => {
    if (video.readyState >= 2) setVideoReady(video);
    else video.addEventListener('loadeddata', () => setVideoReady(video), { once: true });
  });

  const syncVideo = (video) => {
    const shouldPlay = video.dataset.inViewport === 'true' && !document.hidden;
    if (shouldPlay) video.play().catch(() => {});
    else video.pause();
  };

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          video.dataset.inViewport = String(entry.isIntersecting);
          syncVideo(video);
        });
      },
      { rootMargin: '25% 0px', threshold: 0.01 }
    );
    videos.forEach((video) => videoObserver.observe(video));
  }
  document.addEventListener('visibilitychange', () => videos.forEach(syncVideo));

  document.querySelectorAll('[data-preview-signup]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const button = form.querySelector('.signup-submit');
      const label = form.querySelector('.signup-label');
      const success = form.querySelector('.signup-success');
      if (label) label.hidden = true;
      if (success) success.hidden = false;
      if (button) {
        button.classList.add('is-success');
        button.disabled = true;
      }
      const email = form.querySelector('input[type="email"]');
      if (email) email.disabled = true;
    });
  });
})();
